import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import DisplayName from './DisplayName';
import ConstValues from 'utils/const';
import AdminWelcomeEmailActions from 'actions/admin/AdminWelcomeEmailActions';

const {adminWelcomeEmailTypes: TYPES} = ConstValues;

export default class UserReminderTable extends React.PureComponent {
  render() {
    const rows = this.props.users.map(user => {
      return (
        <tr key={user.id}>
          <td>
            <DisplayName user={user} />
          </td>
          <td>{user.email}</td>
          <td>{user.lastEmailed.format('MM/DD/YYYY')}</td>
          <td className="reminders-sent">{user.remindersSent}</td>
          <td>
            <Checkbox
              onChange={() => AdminWelcomeEmailActions.selectItem(TYPES.reminder, user.id)}
              checked={this.props.selected.getIn([TYPES.reminder, user.id])}
            />
          </td>
        </tr>
      );
    });
    return (
      <table className="user-list-table reminder-table">
        <thead>
          <tr>
            <th>Rep</th>
            <th>E-mail</th>
            <th>Last Emailed</th>
            <th className="reminders-sent">Reminders Sent</th>
            <th>Remind</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    );
  }
}
